import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Template24Shop = () => {
    const navigate = useNavigate();
    const [activeCategory, setActiveCategory] = useState('All');
    const [wishlist, setWishlist] = useState({});
    const [hoveredProduct, setHoveredProduct] = useState(null);

    const categories = ['All', 'Saris', 'Kurtas', 'Blouses', 'Stoles', 'Sets'];

    const products = [
        {
            id: 1,
            name: 'Silk Chanderi Drape',
            category: 'Saris',
            price: 14500,
            image: 'https://images.pexels.com/photos/8980747/pexels-photo-8980747.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/7764611/pexels-photo-7764611.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 2,
            name: 'The Monsoon Kurta',
            category: 'Kurtas',
            price: 7800,
            image: 'https://images.pexels.com/photos/6712369/pexels-photo-6712369.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/6712375/pexels-photo-6712375.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 3,
            name: 'Heritage Banarasi Sari',
            category: 'Saris',
            price: 22000,
            image: 'https://images.pexels.com/photos/8285483/pexels-photo-8285483.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/8285167/pexels-photo-8285167.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 4,
            name: 'Evening Silk Blouse',
            category: 'Blouses',
            price: 6500,
            image: 'https://images.pexels.com/photos/6765164/pexels-photo-6765164.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/6764928/pexels-photo-6764928.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 5,
            name: 'Handwoven Stole',
            category: 'Stoles',
            price: 5200,
            image: 'https://images.pexels.com/photos/6567607/pexels-photo-6567607.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/6567340/pexels-photo-6567340.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 6,
            name: 'Linen Summer Set',
            category: 'Sets',
            price: 8800,
            image: 'https://images.pexels.com/photos/6765003/pexels-photo-6765003.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 7,
            name: 'The Archive Jacket',
            category: 'Sets',
            price: 12000,
            image: 'https://images.pexels.com/photos/7679720/pexels-photo-7679720.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/7679454/pexels-photo-7679454.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 8,
            name: 'Cotton Khadi Dress',
            category: 'Kurtas',
            price: 6200,
            image: 'https://images.pexels.com/photos/6712367/pexels-photo-6712367.jpeg?auto=compress&cs=tinysrgb&w=800',
            hoverImage: 'https://images.pexels.com/photos/6712361/pexels-photo-6712361.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
    ];

    const filteredProducts = activeCategory === 'All'
        ? products
        : products.filter(p => p.category === activeCategory);

    const toggleWishlist = (id, e) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-shop {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-shop-hero {
                    padding: 60px 40px 40px;
                    max-width: 1400px;
                    margin: 0 auto;
                }
                .dhara-shop-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 48px;
                    font-weight: 400;
                    color: #1A1A1A;
                    letter-spacing: -1px;
                    margin-bottom: 12px;
                }
                .dhara-shop-subtitle {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    font-weight: 300;
                    letter-spacing: 0.3px;
                }
                .dhara-categories {
                    display: flex;
                    gap: 8px;
                    padding: 0 40px 48px;
                    max-width: 1400px;
                    margin: 0 auto;
                    flex-wrap: wrap;
                }
                .dhara-cat-btn {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0.5px;
                    padding: 10px 24px;
                    border: 1px solid #E5E5E5;
                    background: transparent;
                    color: #6B6B6B;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border-radius: 0;
                }
                .dhara-cat-btn:hover {
                    border-color: #1A1A1A;
                    color: #1A1A1A;
                }
                .dhara-cat-btn.active {
                    background: #1A1A1A;
                    color: #FFFFFF;
                    border-color: #1A1A1A;
                }
                .dhara-products-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 24px;
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 0 40px 120px;
                }
                .dhara-product-card {
                    cursor: pointer;
                    position: relative;
                    group: true;
                }
                .dhara-product-image-wrap {
                    position: relative;
                    overflow: hidden;
                    background: #FAFAF8;
                    aspect-ratio: 3/4;
                    margin-bottom: 20px;
                }
                .dhara-product-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: opacity 0.6s ease;
                }
                .dhara-product-hover-img {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0;
                    transition: opacity 0.6s ease;
                }
                .dhara-product-card:hover .dhara-product-hover-img {
                    opacity: 1;
                }
                .dhara-product-wishlist {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    background: rgba(255,255,255,0.9);
                    border: none;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }
                .dhara-product-card:hover .dhara-product-wishlist {
                    opacity: 1;
                }
                .dhara-product-name {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 6px;
                    letter-spacing: 0.2px;
                }
                .dhara-product-price {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 300;
                    color: #6B6B6B;
                }
                .dhara-product-quick-add {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0, 85, 58, 0.95);
                    color: #FFFFFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 12px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    padding: 14px;
                    border: none;
                    cursor: pointer;
                    opacity: 0;
                    transform: translateY(100%);
                    transition: all 0.3s ease;
                }
                .dhara-product-card:hover .dhara-product-quick-add {
                    opacity: 1;
                    transform: translateY(0);
                }

                @media (max-width: 1024px) {
                    .dhara-products-grid { grid-template-columns: repeat(3, 1fr); }
                }
                @media (max-width: 768px) {
                    .dhara-products-grid {
                        grid-template-columns: repeat(2, 1fr);
                        padding: 0 20px 80px;
                        gap: 16px;
                    }
                    .dhara-shop-hero { padding: 40px 20px 24px; }
                    .dhara-shop-title { font-size: 32px; }
                    .dhara-categories { padding: 0 20px 32px; }
                    .dhara-product-quick-add { opacity: 1; transform: translateY(0); }
                    .dhara-product-wishlist { opacity: 1; }
                }
            `}</style>

            <Header24 />

            <main className="dhara-shop">
                {/* Hero */}
                <div className="dhara-shop-hero">
                    <h1 className="dhara-shop-title">The Collection</h1>
                    <p className="dhara-shop-subtitle">
                        Pieces crafted at the intersection of heritage and modern design
                    </p>
                </div>

                {/* Categories */}
                <div className="dhara-categories">
                    {categories.map(cat => (
                        <button
                            key={cat}
                            className={`dhara-cat-btn ${activeCategory === cat ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                {/* Products Grid */}
                <div className="dhara-products-grid">
                    {filteredProducts.map(product => (
                        <div
                            key={product.id}
                            className="dhara-product-card"
                            onClick={() => navigate(`/template24/product/${product.id}`)}
                            onMouseEnter={() => setHoveredProduct(product.id)}
                            onMouseLeave={() => setHoveredProduct(null)}
                        >
                            <div className="dhara-product-image-wrap">
                                <img
                                    className="dhara-product-img"
                                    src={product.image}
                                    alt={product.name}
                                />
                                <img
                                    className="dhara-product-hover-img"
                                    src={product.hoverImage}
                                    alt={product.name}
                                />
                                <button
                                    className="dhara-product-wishlist"
                                    onClick={(e) => toggleWishlist(product.id, e)}
                                >
                                    <Heart
                                        size={16}
                                        strokeWidth={1.5}
                                        fill={wishlist[product.id] ? '#00553A' : 'none'}
                                        color={wishlist[product.id] ? '#00553A' : '#1A1A1A'}
                                    />
                                </button>
                                <button
                                    className="dhara-product-quick-add"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`/template24/product/${product.id}`);
                                    }}
                                >
                                    View Piece
                                </button>
                            </div>
                            <h3 className="dhara-product-name">{product.name}</h3>
                            <p className="dhara-product-price">
                                {'\u20B9'}{product.price.toLocaleString('en-IN')}
                            </p>
                        </div>
                    ))}
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Template24Shop;
